import { render, staticRenderFns } from "./CalcReminderNotif.vue?vue&type=template&id=63b1343a&scoped=true&"
import script from "./CalcReminderNotif.vue?vue&type=script&lang=js&"
export * from "./CalcReminderNotif.vue?vue&type=script&lang=js&"
import style0 from "./CalcReminderNotif.vue?vue&type=style&index=0&id=63b1343a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b1343a",
  null
  
)

export default component.exports